import React from 'react'
import Button from './button'
import useClientLocation from '../../../hooks/use-client-location'
import useCurrentUser from '../../../hooks/use-current-user'

const PreviewScheduleButton = ({
    visible,
}) => {
    const { toPreviewExperienceSchedule } = useClientLocation()
    const { isStudent } = useCurrentUser()
    if (!visible || !isStudent) {
        return null
    }

    return (
        <Button
            block
            size='lg'
            variant='outline-primary'
            onClick={() => toPreviewExperienceSchedule()}
        >
            PREVIEW SCHEDULE
        </Button>
    )
}

export default PreviewScheduleButton
